import type { FC } from 'react';
// import { useContext } from 'react';
//
// import { Preloader } from '@smartshell/ui-kit';
//
// import { AuthContext } from 'auth';
// import { KKM } from 'cashbox';
// import { FeaturesContext } from 'features';
// import { SettingsContext } from 'settings';
//
// import s from './InitializationHOC.CustomTooltip.module.scss';

// @ts-ignore TODO: incorrect types, check with react types version update (issue: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051)
export const InitializationHOC: FC = ({ children }) => {
  // const {
  //   data: { isAuthInitialized, tokens },
  // } = useContext(AuthContext);
  //
  // const { features } = useContext(FeaturesContext);
  //
  // const {
  //   state: { isInitialized: isSettingsInitialized },
  // } = useContext(SettingsContext);

  // if (!isAuthInitialized || (tokens?.access_token && !isSettingsInitialized)) {
  //   return (
  //     <div className={s.container}>
  //       <Preloader />
  //     </div>
  //   );
  // }
  //
  // if (features.includes('cash_box')) {
  //   return <KKM>{children}</KKM>;
  // }

  return children;
};
